/* AUREN theme — interacciones (vanilla JS, sin dependencias) */
(function () {
  "use strict";

  /* ── Stagger: revela hijos de grid en cascada ────────── */
  function initStagger() {
    var grids = document.querySelectorAll(".ev__grid, .gd__grid, .prod-grid, .trustbar__grid");
    Array.prototype.forEach.call(grids, function (grid) {
      Array.prototype.forEach.call(grid.children, function (child, i) {
        child.style.setProperty("--i", i);
        child.classList.add("reveal");
      });
    });
  }

  /* ── Carrusel de preocupaciones ──────────────────────── */
  function initConcerns() {
    var track = document.querySelector("[data-cn-track]");
    if (!track) return;
    var prev = document.querySelector("[data-cn-prev]");
    var next = document.querySelector("[data-cn-next]");
    if (!prev || !next) return;

    function step() {
      var first = track.children[0];
      return first ? first.getBoundingClientRect().width + 20 : 320;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  /* ── Scroll reveal ────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Announcement rotator ──────────────────────────── */
  function initAnnouncement() {
    var bar = document.querySelector("[data-announcement]");
    if (!bar) return;
    var msgs = bar.querySelectorAll("[data-ann-msg]");
    if (msgs.length < 2) return;
    var i = 0;
    msgs.forEach(function (m, idx) { m.style.display = idx === 0 ? "" : "none"; });
    setInterval(function () {
      msgs[i].style.display = "none";
      i = (i + 1) % msgs.length;
      msgs[i].style.display = "";
      msgs[i].style.animation = "none";
      void msgs[i].offsetWidth;
      msgs[i].style.animation = "annFade .35s ease-out";
    }, 4000);
  }

  /* ── Mobile drawer ────────────────────────────────── */
  function initDrawer() {
    var openBtn = document.querySelector("[data-menu-open]");
    var drawer = document.querySelector("[data-drawer]");
    var overlay = document.querySelector("[data-drawer-overlay]");
    var closeEls = document.querySelectorAll("[data-menu-close]");
    if (!openBtn || !drawer || !overlay) return;
    function open() { drawer.classList.add("open"); overlay.classList.add("open"); document.body.style.overflow = "hidden"; }
    function close() { drawer.classList.remove("open"); overlay.classList.remove("open"); document.body.style.overflow = ""; }
    openBtn.addEventListener("click", open);
    overlay.addEventListener("click", close);
    closeEls.forEach(function (el) { el.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ── FAQ accordion ────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll("[data-faq-q]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        var panel = btn.nextElementSibling;
        btn.setAttribute("aria-expanded", String(!expanded));
        panel.style.maxHeight = expanded ? "0px" : panel.scrollHeight + "px";
      });
    });
  }

  /* ── Testimonials carousel ─────────────────────────── */
  function initTestimonials() {
    var root = document.querySelector("[data-testimonials]");
    if (!root) return;
    var dataEl = root.querySelector("[data-tst-data]");
    var slides = [];
    try { slides = JSON.parse(dataEl ? dataEl.textContent : "[]"); } catch (e) { slides = []; }
    if (!slides.length) return;
    var img = root.querySelector("[data-tst-img]");
    var quote = root.querySelector("[data-tst-quote]");
    var avatar = root.querySelector("[data-tst-avatar]");
    var name = root.querySelector("[data-tst-name]");
    var meta = root.querySelector("[data-tst-meta]");
    var dots = root.querySelectorAll("[data-tst-dot]");
    var thumbs = root.querySelectorAll("[data-tst-thumb]");
    var prev = root.querySelector("[data-tst-prev]");
    var next = root.querySelector("[data-tst-next]");
    var active = 0, timer = null, paused = false;

    function render(i) {
      var s = slides[i];
      if (img) { img.style.opacity = "0"; setTimeout(function () { img.src = s.image; img.alt = "Resultado real de " + s.name; img.style.opacity = "1"; }, 180); }
      if (quote) quote.textContent = s.text;
      if (avatar) avatar.textContent = s.name.charAt(0);
      if (name) name.innerHTML = s.name + ' <span style="font-weight:400">' + s.flag + "</span>";
      if (meta) meta.textContent = s.product + " · " + s.date;
      dots.forEach(function (d, di) { d.classList.toggle("is-active", di === i); });
      thumbs.forEach(function (t, ti) { t.classList.toggle("is-active", ti === i); });
      active = i;
    }
    function go(i) { render((i + slides.length) % slides.length); }
    function start() { stop(); timer = setInterval(function () { if (!paused) go(active + 1); }, 6500); }
    function stop() { if (timer) clearInterval(timer); }

    if (prev) prev.addEventListener("click", function () { go(active - 1); });
    if (next) next.addEventListener("click", function () { go(active + 1); });
    dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { go(i); }); });
    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });

    render(0);
    start();
  }

  /* ── Sticky add-to-cart (móvil, PDP) ──────────────────── */
  function initStickyAtc() {
    var bar = document.querySelector("[data-sticky-atc]");
    var form = document.querySelector(".pdp__form");
    if (!bar || !form) return;
    var realBtn = form.querySelector('button[name="add"]');
    var stickyBtn = bar.querySelector("[data-sticky-atc-btn]");
    if (stickyBtn && realBtn) {
      stickyBtn.addEventListener("click", function () { realBtn.click(); });
    }
    if (!("IntersectionObserver" in window)) { bar.classList.add("show"); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle("show", !e.isIntersecting); });
    }, { rootMargin: "-120px 0px 0px 0px" });
    io.observe(form);
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initStagger();
    initConcerns();
    initReveal();
    initAnnouncement();
    initDrawer();
    initFaq();
    initTestimonials();
    initStickyAtc();
  });
})();
